import { keymirror } from 'app/blocks/common/utils';

const RcaStatusEnum = keymirror({
    AUTHOR_LIST_IS_INCORRECT: '',
    RCA_CONFIRMATION_NEEDED: '',
    RCA_CONFIRMATION_NOT_NEEDED: '',
});

export default RcaStatusEnum;
